import { filter, get } from 'lodash';

import {
    positionEvents,
    positionEventFlowTypes,
    PositionStatuses,
} from '../constants/Position';

const getIsPositionRequiresCalibration = ({ events = [], status = {} }) => {
    const isClosedPosition = [PositionStatuses.CANCELLED, PositionStatuses.CLOSED_BY_ATS, PositionStatuses.FINISHED].includes(status.current);

    if (isClosedPosition) {
        return false;
    }

    const wizardEvents = filter(events, { flowType: positionEventFlowTypes.positionWizard });
    const isJobDefinitionAlreadyCompleted = get(wizardEvents, `${wizardEvents.length - 1}.eventType`, null) === positionEvents.wizardComplete;

    if (!isJobDefinitionAlreadyCompleted) {
        return !events
            .filter(({ flowType }) => flowType === positionEventFlowTypes.feedback)
            .find(({ eventType }) => eventType === positionEvents.feedbackRequested);
    }

    return false;
};

export default getIsPositionRequiresCalibration;
